<svg #svg class="stage-svg" [attr.viewBox]="'0 0 ' + VIEW_W + ' ' + VIEW_H"
     preserveAspectRatio="xMidYMid meet"
     (pointermove)="onPointerMove($event)"
     (pointerup)="onPointerUp($event)"
     (pointercancel)="onPointerUp($event)"
     (pointerleave)="onPointerUp($event)">

  <defs>
    <radialGradient id="cp-crust" cx="42%" cy="38%" r="66%">
      <stop offset="0%" stop-color="#E7A94E" />
      <stop offset="72%" stop-color="#C9812E" />
      <stop offset="90%" stop-color="#A9631C" />
      <stop offset="100%" stop-color="#8A4E15" />
    </radialGradient>
    <radialGradient id="cp-dough" cx="42%" cy="40%" r="70%">
      <stop offset="0%" stop-color="#F7E2B0" />
      <stop offset="100%" stop-color="#E4B96A" />
    </radialGradient>
    <radialGradient id="cp-cheese" cx="40%" cy="36%" r="72%">
      <stop offset="0%" stop-color="#FFE39A" />
      <stop offset="55%" stop-color="#FBC65A" />
      <stop offset="100%" stop-color="#EFA934" />
    </radialGradient>
    <radialGradient id="cp-sauce" cx="45%" cy="40%" r="70%">
      <stop offset="0%" stop-color="#F0663C" />
      <stop offset="100%" stop-color="#CF3A22" />
    </radialGradient>
    <!-- Warm translucent tint for a MARKED (served) slice — texture shows through. -->
    <linearGradient id="cp-mark" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#FFC24D" stop-opacity="0.55" />
      <stop offset="100%" stop-color="#FF8A1E" stop-opacity="0.42" />
    </linearGradient>
    <radialGradient id="cp-pepp" cx="38%" cy="34%" r="70%">
      <stop offset="0%" stop-color="#F0553C" />
      <stop offset="45%" stop-color="#D23A24" />
      <stop offset="100%" stop-color="#9A2416" />
    </radialGradient>
    <radialGradient id="cp-plate-ceramic" cx="38%" cy="32%" r="80%">
      <stop offset="0%" stop-color="#FFFFFF" />
      <stop offset="70%" stop-color="#EEF2F7" />
      <stop offset="100%" stop-color="#D8DFEA" />
    </radialGradient>
    <linearGradient id="cp-plate-rim" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#FFFFFF" />
      <stop offset="50%" stop-color="#E9EEF5" />
      <stop offset="100%" stop-color="#C6CEDB" />
    </linearGradient>
    <radialGradient id="cp-plate-pie" cx="42%" cy="38%" r="72%">
      <stop offset="0%" stop-color="#FBC65A" />
      <stop offset="70%" stop-color="#F0A430" />
      <stop offset="100%" stop-color="#D9791E" />
    </radialGradient>
    <linearGradient id="cp-metal" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#F6F8FB" />
      <stop offset="45%" stop-color="#C4CCD8" />
      <stop offset="70%" stop-color="#98A2B2" />
      <stop offset="100%" stop-color="#7A8496" />
    </linearGradient>
    <linearGradient id="cp-handle" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stop-color="#B9823F" />
      <stop offset="45%" stop-color="#96602E" />
      <stop offset="100%" stop-color="#6E4420" />
    </linearGradient>
    <filter id="cp-shadow" x="-30%" y="-30%" width="160%" height="170%">
      <feDropShadow dx="0" dy="7" stdDeviation="10" flood-color="#5A2E0E" flood-opacity="0.22" />
    </filter>
    <filter id="cp-drop-soft" x="-25%" y="-25%" width="150%" height="150%">
      <feDropShadow dx="0" dy="5" stdDeviation="7" flood-color="#7A3B12" flood-opacity="0.18" />
    </filter>
    <filter id="cp-inner-well" x="-20%" y="-20%" width="140%" height="140%">
      <feComponentTransfer in="SourceAlpha"><feFuncA type="table" tableValues="1 0" /></feComponentTransfer>
      <feGaussianBlur stdDeviation="4" />
      <feOffset dx="0" dy="3" result="off" />
      <feFlood flood-color="#1D2939" flood-opacity="0.30" />
      <feComposite in2="off" operator="in" />
      <feComposite in2="SourceGraphic" operator="atop" />
    </filter>

    <!-- Clip that keeps the plate toppings inside the served mini-pizza. -->
    <clipPath id="cp-plate-slice" *ngIf="platePie"><path [attr.d]="platePie" /></clipPath>
  </defs>

  <!-- The white cutting-board surface is the shell's .play-panel; this SVG
       only draws the pizza / plate / cutter that sit on it. -->

  <g class="board-shake" [class.bumped]="bumped">

    <!-- Fully-detailed life-like base pizza — always a WHOLE pizza -->
    <g class="pizza-base">
      <!-- 1. contact shadow -->
      <ellipse [attr.cx]="CX" [attr.cy]="CY + 14" [attr.rx]="R + 6" [attr.ry]="R - 10" fill="#5A2E0E" opacity="0.16" />
      <!-- 2. crust disc -->
      <circle [attr.cx]="CX" [attr.cy]="CY" [attr.r]="R" fill="url(#cp-crust)" filter="url(#cp-drop-soft)" />
      <!-- 3. crust char spots -->
      <ellipse *ngFor="let c of crustChars" [attr.cx]="c.x" [attr.cy]="c.y" rx="9" ry="6"
               fill="#7A3F14" opacity="0.5" [attr.transform]="'rotate(' + c.rot + ' ' + c.x + ' ' + c.y + ')'" />
      <!-- 4. crust rim light -->
      <circle [attr.cx]="CX" [attr.cy]="CY" [attr.r]="R - 1" fill="none" stroke="#FBE0A0" stroke-width="3" opacity="0.5" />
      <!-- 5. cheese field -->
      <circle [attr.cx]="CX" [attr.cy]="CY" [attr.r]="R - 14" fill="url(#cp-cheese)" filter="url(#cp-inner-well)" />
      <!-- 6. melty cheese edge -->
      <path [attr.d]="cheeseEdge" fill="url(#cp-cheese)" stroke="#E8A63C" stroke-width="2" opacity="0.9" />
      <!-- 7. sauce mottle -->
      <ellipse *ngFor="let s of sauceMottle" [attr.cx]="s.x" [attr.cy]="s.y" rx="34" ry="24"
               fill="url(#cp-sauce)" opacity="0.28" />
      <!-- 8. cheese bubbles -->
      <circle *ngFor="let b of cheeseBubbles" [attr.cx]="b.x" [attr.cy]="b.y" r="3.5" fill="#FFF0C4" opacity="0.7" />
      <!-- 9. base pepperoni -->
      <g *ngFor="let p of basePepp">
        <circle [attr.cx]="p.x" [attr.cy]="p.y" [attr.r]="p.r" fill="url(#cp-pepp)" stroke="#7E1E12" stroke-width="1.5" />
        <circle [attr.cx]="p.x - p.r * 0.3" [attr.cy]="p.y - p.r * 0.3" [attr.r]="p.r * 0.28" fill="#FFFFFF" opacity="0.35" />
        <circle [attr.cx]="p.x + p.r * 0.35" [attr.cy]="p.y + p.r * 0.1" r="1.6" fill="#6E1A0F" />
        <circle [attr.cx]="p.x - p.r * 0.1" [attr.cy]="p.y + p.r * 0.4" r="1.3" fill="#6E1A0F" />
      </g>
      <!-- 10. herb flecks -->
      <ellipse *ngFor="let h of baseHerbs; let i = index" [attr.cx]="h.x" [attr.cy]="h.y" rx="4" ry="2"
               [attr.fill]="i % 4 === 0 ? '#17B26A' : '#2E7D32'"
               [attr.transform]="'rotate(' + h.rot + ' ' + h.x + ' ' + h.y + ')'" />
      <!-- 11. grease sheen -->
      <ellipse class="cp-sheen" [attr.cx]="CX - 60" [attr.cy]="CY - 70" rx="120" ry="80"
               fill="#FFFFFF" opacity="0.12" pointer-events="none" />
    </g>

    <!-- Slices: transparent hit targets; served ones get a highlight-in-place mark -->
    <g *ngFor="let w of wedges" class="wedge" [class.hover]="hoverWedge === w.i"
       (click)="onWedgeTap(w.i)">
      <path class="wedge-shape" [attr.d]="w.path" fill="transparent" />

      <!-- Served: marked ON the pizza (stays flat, no gap, texture shows through) -->
      <g *ngIf="served[w.i]" class="served-mark">
        <!-- warm highlight tint -->
        <path [attr.d]="w.path" fill="url(#cp-mark)" pointer-events="none" />
        <!-- warm/deep outer glow so it separates from the golden pizza -->
        <path [attr.d]="w.path" fill="none" stroke="#FF7A1A" stroke-width="11" stroke-linejoin="round" opacity="0.35" pointer-events="none" />
        <!-- thin dark outline behind the border for definition -->
        <path [attr.d]="w.path" fill="none" stroke="#7A3F14" stroke-width="8" stroke-linejoin="round" pointer-events="none" />
        <!-- bold deep-amber border (high contrast on golden pizza) -->
        <path [attr.d]="w.path" fill="none" stroke="#B5651B" stroke-width="5" stroke-linejoin="round" pointer-events="none" />
      </g>
    </g>

    <!-- Cut guides (spokes) — dashed, pulse on hint -->
    <line *ngFor="let w of wedges" class="spoke" [class.pulse]="hintVisible"
          [attr.x1]="CX" [attr.y1]="CY" [attr.x2]="w.spokeX" [attr.y2]="w.spokeY" />

  </g>

  <!-- Plate: layered glazed ceramic dish holding the built fraction served/den -->
  <!-- 1. cast shadow -->
  <ellipse class="plate" [attr.cx]="PX" [attr.cy]="PY + 18" [attr.rx]="PR + 40" [attr.ry]="(PR + 40) * 0.42"
           fill="#243244" opacity="0.20" filter="url(#cp-shadow)" />
  <!-- 2. rim/lip disc -->
  <circle [attr.cx]="PX" [attr.cy]="PY" [attr.r]="PR + 30" fill="url(#cp-plate-rim)" />
  <!-- 3. rim outer edge -->
  <circle [attr.cx]="PX" [attr.cy]="PY" [attr.r]="PR + 30" fill="none" stroke="#BFC8D6" stroke-width="2" opacity="0.8" />
  <!-- 4. rim top highlight -->
  <path d="M 686 294 A 114 114 0 0 1 902 190" fill="none" stroke="#FFFFFF" stroke-width="4"
        stroke-linecap="round" opacity="0.55" />
  <!-- 5. well step ring -->
  <circle [attr.cx]="PX" [attr.cy]="PY" [attr.r]="PR + 6" fill="none" stroke="#C6CEDB" stroke-width="3" opacity="0.9" />
  <!-- 6. well floor -->
  <circle [attr.cx]="PX" [attr.cy]="PY" [attr.r]="PR" fill="url(#cp-plate-ceramic)" filter="url(#cp-inner-well)" />
  <!-- 7. well glaze sheen -->
  <ellipse [attr.cx]="PX - 26" [attr.cy]="PY - 30" rx="46" ry="30" fill="#FFFFFF" opacity="0.18" pointer-events="none" />
  <!-- 8. served mini-pizza — a real clipped pie with accumulating toppings -->
  <ng-container *ngIf="platePie">
    <g clip-path="url(#cp-plate-slice)">
      <path [attr.d]="platePie" fill="url(#cp-cheese)" />
      <ellipse *ngFor="let m of plateSauce" [attr.cx]="m.x" [attr.cy]="m.y" rx="12" ry="9" fill="url(#cp-sauce)" opacity="0.25" />
      <g *ngFor="let p of platePepp">
        <circle [attr.cx]="p.x" [attr.cy]="p.y" [attr.r]="p.r" fill="url(#cp-pepp)" stroke="#7E1E12" stroke-width="1.2" />
        <circle [attr.cx]="p.x - p.r*0.3" [attr.cy]="p.y - p.r*0.3" [attr.r]="p.r*0.28" fill="#FFFFFF" opacity="0.35" />
      </g>
      <ellipse *ngFor="let h of plateHerbs" [attr.cx]="h.x" [attr.cy]="h.y" rx="3" ry="1.6" fill="#17B26A"
               [attr.transform]="'rotate(' + h.rot + ' ' + h.x + ' ' + h.y + ')'" />
    </g>
    <path [attr.d]="platePieArc" fill="none" stroke="#C9812E" stroke-width="9" stroke-linecap="round" />
    <path [attr.d]="platePieArc" fill="none" stroke="#FBE0A0" stroke-width="2.5" stroke-linecap="round" opacity="0.55" />
    <path class="plate-pie" [attr.d]="platePie" fill="none" stroke="#E8A63C" stroke-width="3" stroke-linejoin="round" />
  </ng-container>
  <text class="plate-frac" [attr.x]="PX" [attr.y]="PY + PR + 70" text-anchor="middle">{{ servedCount }}/{{ den }}</text>
  <text class="plate-label" [attr.x]="PX" [attr.y]="PY - PR - 54" text-anchor="middle">
    {{ currLang === 'ar' ? 'طبقك' : 'your plate' }}
  </text>

  <!-- Sparkles (correct serve) -->
  <g *ngIf="solvedState">
    <circle *ngFor="let s of sparkles" class="sparkle" [attr.cx]="s.x" [attr.cy]="s.y" [attr.r]="s.r"
            [style.animation-delay.ms]="s.delay" fill="#FDB022" />
  </g>

  <!-- Pizza cutter (drag onto a slice to cut it) -->
  <g class="cutter" [class.dragging]="hoverWedge !== null" [attr.transform]="cutterTransform"
     (pointerdown)="onCutterDown($event)">
    <!-- 1. hit area -->
    <rect x="-34" y="-34" width="68" height="120" fill="transparent" />
    <!-- 2. contact shadow (plain, no filter — moving group) -->
    <ellipse cx="0" cy="92" rx="16" ry="6" fill="#3A2410" opacity="0.22" />
    <!-- 3. wooden handle grip -->
    <rect class="cutter-handle" x="-9" y="18" width="18" height="68" rx="9" fill="url(#cp-handle)" stroke="#5A3617" stroke-width="2" />
    <rect x="-5" y="22" width="4" height="58" rx="2" fill="#D6A96A" opacity="0.55" />
    <line x1="-3" y1="26" x2="-3" y2="78" stroke="#5A3617" stroke-width="1" opacity="0.4" />
    <line x1="3" y1="26" x2="3" y2="78" stroke="#5A3617" stroke-width="1" opacity="0.4" />
    <rect x="-11" y="14" width="22" height="10" rx="3" fill="url(#cp-metal)" stroke="#7A8496" stroke-width="1" />
    <!-- 4. fork/bracket behind wheel -->
    <path d="M -7 16 L -7 2 Q 0 -6 7 2 L 7 16 Z" fill="url(#cp-metal)" stroke="#7A8496" />
    <!-- 5. wheel disc -->
    <circle class="cutter-wheel" cx="0" cy="2" r="29" fill="url(#cp-metal)" />
    <!-- 6. serrated rim -->
    <path [attr.d]="wheelTeeth" fill="url(#cp-metal)" stroke="#6E7889" stroke-width="1" stroke-linejoin="round" />
    <circle cx="0" cy="2" r="22" fill="none" stroke="#EAEEF4" stroke-width="2" opacity="0.6" />
    <!-- 7. blade glint -->
    <path class="cp-glint" d="M -18 -8 A 26 26 0 0 1 14 -18" fill="none" stroke="#FFFFFF" stroke-width="3"
          stroke-linecap="round" opacity="0.6" />
    <!-- 8. axle/rivet -->
    <circle cx="0" cy="2" r="7" fill="url(#cp-metal)" stroke="#6E7889" stroke-width="1.5" />
    <circle cx="-2" cy="0" r="2.4" fill="#FFFFFF" opacity="0.7" />
    <!-- 9. active-blade ring -->
    <circle class="cutter-blade-active" cx="0" cy="2" r="33" fill="none" stroke="#F04438" stroke-width="3" opacity="0" />
  </g>

  <!-- Brief red wash to sell the "wrong" feeling -->
  <rect *ngIf="wrongFlash" class="wrong-flash" x="0" y="0" [attr.width]="VIEW_W" [attr.height]="VIEW_H" />
</svg>
